import 'slick-carousel';

export function initAristot() {
  /**
   * Add Aristot class to body
   */
  if ($('.aristot-navbar-sticky').length) {
    $('body').addClass('aristot-styles')
  }

  /**
   * Handle Sticky navbar
   */
  function initStickyBar() {
    const scrolledClass = 'scrolled';
    const navbar = document.querySelector('.navbar-sticky');

    if (navbar == null) {
      return
    }

    const sidebar = document.querySelector('.js-aristot-builder-sidebar');
    const navbarOffset = navbar.offsetTop;
    const navbarHeight = navbar.offsetHeight;
    const main = document.querySelector('.main');

    window.addEventListener('load', function(event) {
      if (main != null) {
        main.style.marginTop = navbarOffset + navbarHeight + 'px';
      }
    })

    window.addEventListener('scroll', function(event) {
      if (main != null) {
        main.style.marginTop = navbarOffset + navbarHeight + 'px';
      }
      const isScrolled = window.scrollY > navbarOffset;

      navbar.classList.toggle(scrolledClass, isScrolled);
      if (sidebar !== null) {
        sidebar.classList.toggle(scrolledClass, isScrolled);
      }
    })
  }

  initStickyBar();

  /**
   * Navbar Trigger
   */
  const $navbarTrigger = $('.js-navbar-trigger');
  const $navbarActions = $('.navbar__actions');

  $navbarTrigger.on('click', function(event) {
    event.preventDefault();

    $navbarTrigger.toggleClass('clicked');

    $navbarActions.slideToggle()

    $('body').toggleClass('js-no-scroll-mobile');
  });

  /**
   * Navbar Accordion Mobile
   */

  function initAccordion() {
    const isDesktop = $(window).width() > 1023;
    const clickedOnceClass = 'clicked-once';

    $('.has-dropdown > a, .has-megamenu > a').on('click', function(event) {
      const $this = $(this);

      if (isDesktop || $this.parent().hasClass(clickedOnceClass)) {
        return true
      }

      event.preventDefault();

      $this
        .siblings().slideDown()
        .parent().addClass(clickedOnceClass)
        .siblings().removeClass(clickedOnceClass)
        .find('.dropdown, .megamenu').slideUp()
    });
  }

  initAccordion()

  /**
   * Aristot Accordion
   */

  const accordionActiveClass = 'is-active';

  $('.aristot-accordion .accordion__head').on('click', function(event) {
    $(this)
      .siblings().slideToggle()
      .parent().toggleClass(accordionActiveClass)
      .siblings().removeClass(accordionActiveClass)
      .find('.accordion__body').slideUp();
  });

  /**
   * Bassinet Builder Sliders
   */

  const $sliderTop = $('.js-aristot-slider.slider-builder-top');
  const $sliderBot = $('.js-aristot-slider.slider-builder-bottom');
  const sliderSettings = {
    centerMode: true,
    centerPadding: '20%',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          centerPadding: 0,
          arrows: false
        }
      }
    ]
  }

  $sliderTop.find('.slider__slides').slick(sliderSettings);
  $sliderBot.find('.slider__slides').slick(sliderSettings);


  /**
   * Sticky Sidebar
   */

  function initStickySidebar() {
    const $sidebar = $('.js-aristot-builder-sidebar');

    if ($sidebar.length == 0) {
      return
    }

    const sidebarHeight = $sidebar.height();
    const $sidebarContainer = $sidebar.parent();
    const $win = $(window)
    const navbar = document.querySelector('.navbar-sticky');
    const navbarHeight = navbar.offsetHeight;

    $win.on('scroll', function(event) {
      const scroll = $win.scrollTop()

      const isAtBottom = scroll + sidebarHeight - navbarHeight >=  $sidebarContainer.height()

      $sidebar.toggleClass('sticky-bottom', isAtBottom);
    });
  }

  initStickySidebar();


  /**
   * Mobile Gallery Slider
   */

  $('.aristot-section-gallery').slick({
    arrows: false,
    dots: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 768,
        settings: 'unslick'
      }
    ]
  })

  /**
   * Alternate resolution images
   */

  function initAlternateResolutionImages() {
    const isMobile = $(window).width() < 768;
    const $imageContainers = $('.js-alt-image');

    if ($imageContainers.length) {
      $imageContainers.each((index, item) => {
        if (isMobile) {
          const mobileImage = item.querySelector('.image-mobile')
          if (mobileImage != null) {
            mobileImage.style = `background-image: url('${mobileImage.getAttribute('data-bg')}')`
          }
        }
        else {
          const desktopImage = item.querySelector('.image-desktop')
          if (desktopImage != null) {
            desktopImage.style = `background-image: url('${desktopImage.getAttribute('data-bg')}')`
          }
        }
      });
    }
  }

  initAlternateResolutionImages();

  $('.navbar-sticky a[href^="#"]').on('click', function(event) {
    event.preventDefault();

    const $target = $(this.hash);
    const $navTrigger = $('.js-navbar-trigger');

    if ($target.length == 0) {
      const fallback = this.dataset.fallback;

      if (fallback != null) {
        location.href = fallback + '/' + this.hash
      }
    }

    $('html, body').animate(
    {
      scrollTop: $target.offset().top,
    },
    500,
    'linear'
    )

    if ($navTrigger.hasClass('clicked')) {
      $navTrigger.first().click()
    }
  });

  if (location.hash && $(location.hash).length) {
    $('html, body').animate(
    {
      scrollTop: $(location.hash).offset().top,
    },
    500,
    'linear'
    )
  }
}
